/* global algoliasearch, instantsearch, $ */

var search;
var helper;

// Algolia API credentials to setup InstantSearch.js
const ALGOLIA_SEARCH = {
    appId: '6RCFK5TOI5',
    apiKey: '521c444a09acd62368618fce7f15dafa',
    indexName: 'G4_HELP'
};

const initInstantSearch = () => {
    const searchClient = algoliasearch(ALGOLIA_SEARCH.appId, ALGOLIA_SEARCH.apiKey);
    search = instantsearch({
        indexName: ALGOLIA_SEARCH.indexName,
        searchClient,
        searchFunction(helper) {
            const container = document.querySelector('#hits');
            container.style.display = helper.state.query === '' ? 'none' : '';

            if (helper.state.query) {
                helper.search();
            }

        }
    });

    search.addWidgets([
        {
            init(opts) {
                helper = opts.helper;
                const input = document.querySelector('#search-input');
                input.addEventListener('input', ({currentTarget}) => {
                    helper.setQuery(currentTarget.value) // update the parameters
                        .search(); // launch the query

                    if (currentTarget.value) {
                        $('body').addClass('search-active');
                        document.getElementById('reset-search').style.display = 'flex';
                    } else {
                        $('body').removeClass('search-active');
                        document.getElementById('reset-search').style.display = 'none';
                    }
                });
            },
            render({state}) {
                // Handle rendering widgets based on query and results
                $('#hits').show();

                if (!state.query || state.query.length < 1) {
                    $('#hits').hide();
                }
            }
        },
        instantsearch.widgets.configure({
            attributesToSnippet: ['html:20']
        }),
        instantsearch.widgets.hits({
            container: '#hits',
            cssClasses: {
                root: 'search-results',
                list: 'search-results-list',
                emptyRoot: 'search-empty-results',
                item: 'search-result-item'
            },
            templates: {
                empty: 'No results found',
                item(hit) {
                    return `<a class="search-result-link" href="${hit.url}">
                                <span class="tag-${hit.tags.length ?
                                    hit.tags
                                        .reduce((prev, current) => {
                                            if (!/hash/.test(current.slug)) {
                                                prev.push(current.slug);
                                            }

                                            return prev;
                                        }, [])
                                        .join(' tag-') : ""}">${hit.tags.length && !/hash/.test(hit.tags[0].slug) ? hit.tags[0].name : ""}</span>
                                <div class="search-result-content">
                                    <span>${instantsearch.highlight({attribute: 'title', hit: hit})}</span>
                                    <p>${instantsearch.snippet({attribute: 'html', hit})}...</p>
                                </div>
                            </a>`;
                }
            }
        })
    ]);

    search.start();
};


$(document).ready(function () {
    // Bootup instantSearch

    $('.main-section-nav .search-button').click(function() {
        $('.main-section-nav .search').addClass('show');
        $('.hide-on-search').hide();
        $('.main-section-nav #search-input').focus();
        $('.main-section-nav').css('position', 'relative');
    });

    $('.main-section-nav #search-input').on('focusout', function() {
        if (!$(this).val()) {
            $('.main-section-nav .search').removeClass('show');
            $('.hide-on-search').show();
            $('.main-section-nav').css('position', 'sticky');
        }
    });

    const searchInput = document.getElementById('search-input');
    if (searchInput && document.getElementById('hits')) {

        // Only render search where it should be
        initInstantSearch();

        function placeholderResize() {
            const placeholderWide = 'Search Ghost Help Center...';
            const placeholderSmall = 'Search Help Center...';
            const placeholderTiny = 'Search Help...';

            if (searchInput.offsetWidth < 200) {
                document.getElementById('search-input').setAttribute('placeholder', placeholderTiny);
            } else if(searchInput.offsetWidth < 400) {
                document.getElementById('search-input').setAttribute('placeholder', placeholderSmall);
            } else {
                document.getElementById('search-input').setAttribute('placeholder', placeholderWide);
            }
        };

        placeholderResize();

        $(document).on('keyup', function (e) {
            if (e.keyCode === 27 && $('body').hasClass('search-active')) {
                $('#search-input').val('');
                $('body').removeClass('search-active');
                document.getElementById('reset-search').style.display = 'none';
                document.getElementById('start-search').style.display = 'flex';

                helper.setQuery('') // update the parameters
                    .search(); // launch the query
            }
        });

        $(window).on('resize', function () {
            placeholderResize();
        });

        $('#start-search').on('click', function (e) {
            e.preventDefault();
            $('#search-input').focus();
        });

        $('#reset-search').on('click', function (e) {
            e.preventDefault();
            $('#search-input').val('');
            $('#search-input').focus();
            $('body').removeClass('search-active');
            document.getElementById('reset-search').style.display = 'none';
            document.getElementById('start-search').style.display = 'flex';

            helper.setQuery('') // update the parameters
                .search(); // launch the query
        });
    }
});
